export default function cleanMakeModelNames(str) {
    const leadingDash = /^-+/i;
    const modelCount = /\s\(\d+\)/ig;
    const spaces = /\s/gi;

    if (str && typeof str === 'string') {
        return str.toLowerCase()
            .replace(modelCount, '')
            .replace(spaces, '-')
            .replace(leadingDash, '');
    }
    return str;
}
